import appConfig from "../config/app.config";
import axios from "axios";

const getRewardList = () => {
  return new Promise((resolve, reject) => {
    const data = null;

    const config = {
      method: "get",
      url: `${appConfig.apiUrl.rewardList}?subscription_ids=1`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "Content-Type",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const optInReward = (planId, token) => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "put",
      url: `${appConfig.apiUrl.activateReward}?plan_id=${planId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const optOutReward = (planId, token) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "put",
      url: `${appConfig.apiUrl.deactivateReward}?plan_id=${planId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const getUserRewards = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: appConfig.apiUrl.getUserPlan,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export { getRewardList, optInReward, getUserRewards, optOutReward };
